
export { AccordionNavigationType } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-consumer-deploy-prod/libs/shared/models/src/lib/accordionNavigation.models.ts"